const painPoints = [
  'Slow response to inbound solar inquiries',
  'Missed consultation booking opportunities',
  'Weak follow-up on proposals and financing',
  'Long conversion timelines with no nurture system',
];

const solutions = [
  'Instant AI response to every solar inquiry',
  'Automated consultation booking and reminders',
  'Structured proposal follow-up sequences',
  'Long-cycle drip campaigns that close more deals',
];

const solarStats = [
  { value: '4.2x', label: 'More consultations booked' },
  { value: '58%', label: 'Faster lead response time' },
  { value: '3x', label: 'Higher proposal close rate' },
];

export default function SolarSection() {
  return (
    <section className="bg-[#F8FAFC] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="rounded-2xl overflow-hidden border border-slate-100" style={{ height: '480px' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/13fd2bb1acaefa28eddb55a288576f81.jpg"
              alt="Solar sales consultation with homeowner discussing proposal"
              title="Solar Company Automation System"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-5">
              Solar &amp; Energy
            </span>
            <h2 className="text-4xl font-extrabold text-[#0F172A] mb-5 leading-tight">
              Solar &amp; Energy Providers
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              Built for longer sales cycles and consultation-based selling. Solar
              deals don&apos;t close overnight—they require consistent touchpoints,
              financing conversations, and proposal follow-ups over weeks or
              months. Our automation keeps every deal alive without manual effort.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              <div className="bg-red-50 rounded-2xl p-6 border border-red-100">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-error-warning-line text-red-500 text-sm" />
                  </div>
                  <p className="text-red-700 text-sm font-bold uppercase tracking-wide">Pain Points</p>
                </div>
                <ul className="space-y-2">
                  {painPoints.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-slate-600">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-close-line text-red-400 text-sm" />
                      </div>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-green-50 rounded-2xl p-6 border border-green-100">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-check-double-line text-green-600 text-sm" />
                  </div>
                  <p className="text-green-700 text-sm font-bold uppercase tracking-wide">Our Solution</p>
                </div>
                <ul className="space-y-2">
                  {solutions.map((s) => (
                    <li key={s} className="flex items-start gap-2 text-sm text-slate-600">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-green-500 text-sm" />
                      </div>
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4">
              {solarStats.map((stat) => (
                <div key={stat.label} className="text-center bg-white rounded-xl p-4 border border-slate-100">
                  <div className="text-2xl font-extrabold text-blue-600 mb-1">{stat.value}</div>
                  <div className="text-slate-500 text-xs leading-snug">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
